import React from "react";

const Offline = () => {
    return (
        <div className="offline-info">
            <h1>Connection error</h1>
            <p>please check your internet connection and try again</p>
        </div>
    );
};

export default Offline;
